import { connect } from "react-redux"
import React from "react"
import styled from "styled-components"
import Text from "../../common/components/Text"
import { responsive } from "buoy-theme"
import { ButtonLink } from "buoy-core"

import * as actions from "../actions"
import { scroll } from "../../common/common"

import MoreOptions from "./MoreOptions"
import ResponseSwitch from "./ResponseSwitch"

const VALID_TYPES = [
  "radio",
  "checkbox",
  "duration",
  "search",
  "freetext",
  "location",
  "integration",
  "age",
  "text",
  "email",
  "password",
  "setPassword",
  "employer",
  "specialist",
  "diagnosis",
  "dxocCloseMessage",
]

const Wrapper = styled.div`
  margin-top: ${props => props.marginTop}px;
  margin-bottom: 24px;
  min-height: ${props => props.minHeight}px;
  display: flex;
  justify-content: center;
  width: 100%;
`

const ResponseOptions = styled.div`
  max-width: 560px;
  width: 100%;
  ${responsive("padding", "0 32px", "0 32px", "0 32px", "0 32px", "0 16px")};
`

const EditWrapper = styled.div`
  display: flex;
  justify-content: flex-end;
  margin-bottom: ${props =>
    props.checkbox ? `50px` : props.bottom ? `6px` : "0"};
`

const ScrollToBottom = styled(ButtonLink)`
  cursor: pointer;
  pointer-events: all;
  text-decoration: none;
  :focus {
    outline: none;
  }

  ${props => !props.show && `display: none;`}
`

const atBottom = () => {
  let questionReport = document.getElementsByClassName("question-report")
  let answerOptions = document.getElementsByClassName("answer-option")

  if (!answerOptions.length && !questionReport.length) return true

  let bottomElement = questionReport.length
    ? questionReport[0]
    : answerOptions[answerOptions.length - 1]
  return (
    window.pageYOffset +
      window.innerHeight -
      (window.pageYOffset +
        bottomElement.getBoundingClientRect().top +
        bottomElement.offsetHeight) >
    0
  )
}

const scrollBottom = () => {
  scroll()
}

const Response = props => {
  let index = props.activeIndex
  while (index > 0 && !VALID_TYPES.contains(props.chatItems[index].inputType)) {
    index--
  }
  let activeItem = props.chatItems[index]
  if (
    !activeItem ||
    activeItem.filter ||
    (!props.isClient && props.showIntegrationChat) ||
    (!props.isClient && props.completed && index !== props.activeIndex) ||
    activeItem.type === "clarifier" ||
    props.chatItems[props.activeIndex].type === "symptomBubble"
  ) {
    return <span />
  }
  let inputBar = activeItem.inputType === "search"

  let editing = props.activeIndex < props.chatItems.length - 2 && !inputBar
  let hide =
    (index !== props.activeIndex &&
      props.chatItems[props.activeIndex].type !== "error") ||
    (props.loading && activeItem.type !== "location") ||
    activeItem.type === "search"

  let { moreOptions, editorActive } = props
  let isCheckBox = activeItem.inputType === "checkbox"

  const interviewEnd =
    props.chatItems[props.chatItems.length - 1].disableScroll === true

  return (
    <Wrapper id="response" {...props}>
      <ResponseOptions>
        <MoreOptions show={moreOptions && !hide && !editorActive}>
          <ScrollToBottom
            onClick={scrollBottom}
            show={moreOptions && !hide && !editorActive}
          >
            {interviewEnd ? "New Message" : "More Options"}
          </ScrollToBottom>
        </MoreOptions>
        {editing && (
          <EditWrapper key="edit-header" bottom>
            <Text size="bodySmall" color="neutralDarkest">
              Editing answer
            </Text>
          </EditWrapper>
        )}
        <ResponseSwitch
          key={index + hide.toString()}
          {...props}
          hide={hide}
          activeIndex={index}
          editing={editing}
        />
        {editing && (
          <EditWrapper key="edit-footer" checkbox={isCheckBox} bottom>
            <ButtonLink margin="0 0 12px" onClick={props.cancelEdit}>
              Cancel
            </ButtonLink>
          </EditWrapper>
        )}
        {props.show_terms_subtext && (
          <EditWrapper>
            <Text color="neutral" size="bodySmall">
              By clicking, you agree to our{" "}
              <ButtonLink margin="0 0 12px" onClick={props.showTerms}>
                terms of service
              </ButtonLink>
            </Text>
          </EditWrapper>
        )}
      </ResponseOptions>
    </Wrapper>
  )
}

class ResponseWrapper extends React.Component {
  constructor(props) {
    super(props)
    this.state = { marginTop: 0, minHeight: 0, moreOptions: false }
  }

  componentDidMount() {
    this.setState({ minHeight: window.innerHeight / 4 })
    window.addEventListener("resize", this.updateCalculatedStyles)
    window.addEventListener("scroll", this.hideMoreOptions)
  }

  componentWillUnmount() {
    window.removeEventListener("resize", this.updateCalculatedStyles)
    window.removeEventListener("scroll", this.hideMoreOptions)
  }

  hideMoreOptions = (delay = true) => {
    this.setState({ moreOptions: false })

    if (delay) {
      if (this.scrollTimer) clearInterval(this.scrollTimer)

      this.scrollTimer = setTimeout(() => {
        let response = document.getElementById("response")
        let isMinHeight = response
          ? parseInt(response.clientHeight - window.innerHeight / 4, 10) < 10
          : false
        if (!atBottom() && !isMinHeight) {
          this.setState({ moreOptions: true })
        }
        this.scrollTimer = null
      }, 500)
    }
  }

  showMoreOptions = () => {
    let response = document.getElementById("response")
    let isMinHeight = response
      ? parseInt(response.clientHeight - window.innerHeight / 4, 10) < 10
      : false
    if (!atBottom() && !isMinHeight && !this.scrollTimer) {
      this.setState({ moreOptions: true })
    } else {
      this.setState({ moreOptions: false })
    }
  }

  updateCalculatedStyles = () => {
    this.setState({ minHeight: window.innerHeight / 4 })
  }

  render() {
    return (
      <Response
        {...this.props}
        marginTop={this.state.marginTop}
        minHeight={this.state.minHeight}
        moreOptions={this.state.moreOptions}
        showMoreOptions={this.showMoreOptions}
        hideMoreOptions={this.hideMoreOptions}
      />
    )
  }
}

const mapDispatchToProps = dispatch => ({
  submitFilters: () => dispatch(actions.submitFilters()),
  cancelEdit: () => dispatch(actions.cancelEdit()),
  showTerms: () => dispatch(actions.setTermModalShown(true)),
  dispatch,
})

const mapStateToProps = (state, ownProps) => ({
  chatItems: ownProps.chatItems || state.chatList.items,
  activeIndex:
    ownProps.activeIndex !== undefined
      ? ownProps.activeIndex
      : state.chatList.active,
  loading: state.loading,
  searchActive: state.search.active,
  zipcode: state.integration.zipcode,
  showIntegrationChat: state.integration.showIntegrationChat,
  completed: state.completion.completed,
  editorActive: state.editor.isActive,
  isAnonymous: state.auth.isAnonymous,
  show_terms_subtext:
    state.brand.name &&
    !state.brand.require_terms &&
    state.brand.terms &&
    state.chatList.items.length === 1,
})

const ResponseContainer = connect(
  mapStateToProps,
  mapDispatchToProps
)(ResponseWrapper)

export { ResponseContainer as default, ResponseWrapper, Response }



// WEBPACK FOOTER //
// ./assets/interview/components/Response.js